import {
    ILiteTradeAssetSymbol,
    ILiteTradePortfolioPosition,
} from '../../../../../modules/LiteTrade/types/liteTradeReducer.t';
import { Slider } from '../../../../../components/Slider/Slider';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { closeAllPositionsAction } from '../../../../../modules/LiteTrade/liteTradeActions';
import { useDispatch, useSelector } from 'react-redux';
import { getCloseAllPositionsIsLoading } from '../../../../../modules/LiteTrade/liteTradeSelectors';
import SlideMobileCloseAllPositionsModal from './SlideMobileCloseAllPositionsModal';

export interface ISlideMobileCloseAllPositions {
    onClose: () => void,
    positions: ILiteTradePortfolioPosition[],
    show: boolean,
    sumPl: number,
    symbol: ILiteTradeAssetSymbol,
}

const SlideMobileCloseAllPositions = (props: ISlideMobileCloseAllPositions) => {
    const {
        onClose,
        positions,
        show,
        sumPl,
        symbol,
    } = props;

    const dispatch = useDispatch();
    const isProgress = useSelector(getCloseAllPositionsIsLoading);
    const prevStateProgress = useRef(false);

    const closeAllPositionsHandler = useCallback(() => {
        dispatch(closeAllPositionsAction({
            sumPl,
            symbol,
        }));
    }, [dispatch, sumPl, symbol]);

    const hasInactivePositions = useMemo(() => {
        return positions.some((position) => !position.assetInstance.isTradingNow());
    }, [positions]);

    useEffect(() => {
        if (prevStateProgress.current && !isProgress) {
            onClose();
        }
        prevStateProgress.current = isProgress;
    }, [isProgress, onClose]);

    return <Slider showCloseButton={false}
                   placement={'bottom'}
                   popUpClassName={'action-sheet'}
                   show={show}
                   onClose={onClose}
    >
        <SlideMobileCloseAllPositionsModal amount={positions.length.toString()}
                                           closeAllPositionsHandler={closeAllPositionsHandler}
                                           sumPl={sumPl} onClose={onClose} hasInactivePositions={hasInactivePositions}
                                           isProgress={isProgress}/>
    </Slider>;
};

export default SlideMobileCloseAllPositions;
